
import { createApp } from 'vue';
import App from './App.vue';
import './style.css';
import router from './router';

import PrimeVue from 'primevue/config';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import Aura from '@primeuix/themes/aura';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import Tooltip from 'primevue/tooltip';




const app = createApp(App);



// Usar plugins
app.use(router);
app.use(Toast, {
    position: "top-right",
    timeout: 2000,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true
});
app.directive('tooltip', Tooltip);
app.use(PrimeVue, {
    // Default theme configuration
    theme: {
        preset: Aura,
        options: {
            prefix: 'p',
            darkModeSelector: '',
            cssLayer: false
        }
    }
});

app.mount('#app');
